import { log as serverLog, error as serverError } from './utils/serverLogger.js';

function getTranslateApiUrl() {
    const env = import.meta.env.VITE_TRANSLATE_API_URL;
    if (env) {
        if (env.startsWith('http')) return env;
        const base = typeof window !== 'undefined' ? window.location.origin : '';
        return base + (env.startsWith('/') ? env : '/' + env);
    }
    if (typeof window !== 'undefined' && window.location.origin && !window.location.origin.includes('localhost'))
        return window.location.origin + '/translate';
    return 'http://localhost:5002/translate';
}

const getTranslate = async (text) => {
    const url = getTranslateApiUrl();
    console.log("[translate] Request start", { url, textLength: text?.length });
    serverLog("[translate] Request start", { url, textLength: text?.length });
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ text })
        });
        const responseText = await response.text();
        if (!response.ok) {
            console.error("[translate] Request failed", { status: response.status, statusText: response.statusText, body: responseText });
            serverError("[translate] Request failed", { status: response.status, statusText: response.statusText, body: responseText });
            throw new Error(`Translation failed (${response.status}): ${responseText || response.statusText}`);
        }
        let result;
        try {
            result = JSON.parse(responseText);
        } catch (parseError) {
            console.error("[translate] Invalid JSON response", responseText);
            serverError("[translate] Invalid JSON response", responseText);
            throw new Error("Translation server returned invalid response");
        }
        if (result.translation == null) {
            console.error("[translate] Missing translation in response", result);
            serverError("[translate] Missing translation in response", result);
            throw new Error("Translation server did not return a translation");
        }
        console.log("[translate] Success", { textLength: text?.length });
        serverLog("[translate] Success", { textLength: text?.length });
        return result.translation;
    } catch (error) {
        console.error("[translate] Error:", error.message, error);
        serverError("[translate] Error", { message: error.message });
        throw error;
    }
}

export default getTranslate;